import { ResetPasswordService } from 'application/services/reset-password'
import { api } from 'infra/adapters/http-client-adapter'

export const handleResetPassword = new ResetPasswordService(api)
